import sampleCombine from 'xstream/extra/sampleCombine'
import xs from 'xstream'

export function Cards ({DOM}) {
  const cardElement$ = DOM.element()
  const init$ = cardElement$
    .take(1)
    .map((card) => () => {
      card.classList.remove('-opened')
      card.classList.add('-closed')
    })

  const toggleCard$ = DOM
    .select('[data-carditem-togglecontent]')
    .events('click')
    .compose(sampleCombine(cardElement$))
    .map(([, card]) => () => {
      card.classList.toggle('-opened')
      card.classList.toggle('-closed')
    })

  return {
    DOM: xs.merge(init$, toggleCard$),
  }
}

export default Cards



// WEBPACK FOOTER //
// ./cards/index.js